import { MSG_ERROR, MSG_HIDE, MSG_INFO, MSG_SUCCESS, MSG_WRRING } from "./MasgTypes";

const initialState = {
    payload: { message: "", severity: "info", open: false }
}

function MsgReducer(state = initialState, action: any) {
    switch (action.type) {
        case MSG_INFO:
            return { ...action.payload }
        case MSG_SUCCESS:
            return { ...action.payload }
        case MSG_WRRING:
            return { ...action.payload }
        case MSG_ERROR:
            return { ...action.payload }
        case MSG_HIDE:
            return { ...action.payload }
        default:
            return state
    }
}
export default MsgReducer